var parent = require('../../actual/instance/push');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/full/instance/push.js
// module id = tKW5
// module chunks = 0